// Paramètres de la liste des commandes : pagination, filtres choisis dans la page et filtres imposés par l'écran
// (classification et source passent par les filtres choisis).

export function countActiveFilters(f) {
    return [
        f.selectedStatuts.length > 0,
        !!f.selectedDateDebut || !!f.selectedDateFin,
        !!f.selectedEhpadId,
        f.selectedTournees.length > 0,
        !!f.patientSearch,
        !!f.patientDateNaissance,
        !!f.selectedClassificationPatient,
        !!f.selectedClassificationMedicament,
        !!f.selectedSource,
        f.readFilter !== null,
        f.favoriteFilter !== null,
        !!f.medicamentSearch,
    ].filter(Boolean).length;
}

const OPTIONAL_PARAMS = [
    ["dateDebut", "selectedDateDebut"],
    ["dateFin", "selectedDateFin"],
];
const SEARCH_PARAMS = [
    ["patientSearch", "patientSearch"],
    ["patientDateNaissance", "patientDateNaissance"],
    ["classificationPatient", "selectedClassificationPatient"],
    ["classificationMedicament", "selectedClassificationMedicament"],
    ["source", "selectedSource"],
    ["serviceKey", "serviceKey"],
];

export function buildCommandeListParams(f) {
    const params = new URLSearchParams();
    params.append("page", String(f.page));
    params.append("size", String(f.size));
    OPTIONAL_PARAMS.forEach(([name, key]) => { if (f[key]) params.append(name, f[key]); });
    if (f.selectedEhpadId) params.append("ehpadId", String(f.selectedEhpadId));
    f.selectedTournees.forEach(tournee => params.append("tournee", tournee));
    f.selectedStatuts.forEach(s => params.append("statut", s));
    SEARCH_PARAMS.forEach(([name, key]) => { if (f[key]) params.append(name, f[key]); });
    if (f.readFilter !== null) params.append("read", String(f.readFilter));
    if (f.favoriteFilter !== null) params.append("favorite", String(f.favoriteFilter));
    if (f.medicamentSearch) params.append("medicamentSearch", f.medicamentSearch);
    Object.entries(f.filters || {}).forEach(([k, v]) => {
        if (k === "classificationPatient" || k === "source") return;
        if (Array.isArray(v)) v.forEach(item => params.append(k, item));
        else params.append(k, v);
    });
    return params;
}
